import React from 'react';
import { Button, ButtonGroup, FormControl } from '@mui/material';
import { ConjsProps } from '@react-awesome-query-builder/core';

// interface Props {
//   id: string;
//   not: boolean;
//   setNot: (state: boolean) => void;
//   conjunctionOptions: any;
//   setConjunction: any;
//   disabled: boolean;
//   readonly: boolean;
//   config: Config;
// }

export function Conjs(props: ConjsProps | undefined): React.ReactElement {
  if (!props) {
    return <></>;
  }
  const { not, setNot, conjunctionOptions, setConjunction, disabled, readonly, config } = props;
  //TIP: disabled=true if only 1 rule; readonly=true if immutable mode
  const conjsCount = Object.keys(conjunctionOptions || {}).length;
  const lessThenTwo = disabled;

  return (
    <FormControl>
      <ButtonGroup disableElevation variant="contained" disabled={readonly}>
        {config?.settings.showNot && (!readonly || not) && (
          <Button color={not ? 'primary' : 'info'} onClick={() => setNot(!not)} disabled={readonly}>
            {config.settings.notLabel || 'NOT'}
          </Button>
        )}
        {conjsCount > 1 &&
          !lessThenTwo &&
          Object.keys(conjunctionOptions || {}).map(key => {
            if (!conjunctionOptions?.[key]) {
              throw new Error('Could not initiate query builder');
            }
            const { id, label, checked } = conjunctionOptions[key];
            // const postfix = (setConjunction as any).isDummyFn ? '__dummy' : '';

            if (readonly && !checked) {
              return null;
            }

            return (
              <Button
                key={id}
                id={id}
                color={checked ? 'secondary' : 'info'}
                value={key}
                onClick={() => setConjunction(key)}
                disabled={readonly}
              >
                {label}
              </Button>
            );
          })}
      </ButtonGroup>
    </FormControl>
  );
}
